import { Status } from "../types";

export type TranslationMap = {
  [key: string]: string | TranslationMap;
};

export type LocaleTranslations = {
  [locale: string]: {
    [key: string]: string | TranslationMap;
  };
};

const canonical = {
  nav: {
    home: "Home",
    map: "Map",
    info: "Info",
    today: "Today",
    more: "More"
  },
  announcements: {
    singular: "Announcement",
    plural: "Announcements",
    title: "Today’s Announcements",
    noAnnouncements: "No announcements for today.",
    continue: "Continue to app"
  },
  home: {
    parkHours: "Today’s Hours",
    announcements: "Announcements",
    upcomingEvents: "Upcoming Events"
  },
  event: {
    schedule: {
      time: "Event Time",
      location: "Event Location",
      to: "to",
      noShowings: "No showings",
      closed: "Closed",
      today: "{{day}} (today)",
      otherDays: "{{day}}"
    }
  },
  screens: {
    schedule: {
      noEvents: "No events scheduled",
      announcementsTitle: "Announcements"
    }
  },
  placeTypes: {
    title: "Places",
    noPlaces: "No locations found for “{{label}}”"
  },
  places: {
    nearby: "Nearby",
    explore: "Explore",
    schedule: {
      dayOfWeek: "Day of Week",
      hours: "hours",
      today: "{{day}} (today)",
      otherDays: "{{day}}"
    }
  },
  appInfo: {
    title: "App Info",
    applicationBy: "Application by:",
    version: "Version"
  },
  dailySchedule: {
    title: "Today’s Schedule",
    pastEvents: "Past Events",
    inProgress: "In Progress",
    laterToday: "Later Today",
    time: "Time"
  },
  hours: {
    openingSoon: "Opening Soon",
    closed: "Closed",
    closingSoon: "Closing Soon",
    opening: "Opening Later",
    atTime: "at {{time}}",
    open: "Open",
    openNow: "Open Now",
    opens: "Opens",
    closes: "Closes",
    tdb: "TBD" // to be determined
  },
  status: {
    [Status.ACTIVE]: "Active",
    [Status.INACTIVE]: "Not in Operation",
    [Status.ON_HOLD]: "On Hold",
    [Status.OUT_LATE]: "Out Late",
    [Status.CLOSED_TEMPORARILY]: "Closed Today",
    [Status.CLOSED_SEASONALLY]: "Closed Seasonally",
    [Status.CLOSED_PERMANENTLY]: "Closed Permanently"
  },
  countdown: {
    happeningNow: "Happening now",
    startingAt: "Starting at {{time}}",
    startingIn: "Starting in {{minutes}}m",
    aboutToStart: "About to start"
  },
  appbar: {
    returnLink: "Return to previous screen"
  },
  openStatus: {
    now: "Now",
    at: "at",
    until: "until {{time}}",
    doneForDay: "Done for day",
    noShowings: "No showings"
  },
  timestamp: {
    label: "{{time}}"
  },
  weekday: {
    label: "{{day}}"
  },
  guides: {
    closeMenu: "Close Menu",
    exitFullscreen: "Exit Fullscreen"
  },
  maps: {
    missing: "No map available",
    loading: "Loading map...",
    debug: {
      tapLocate: "Tap anywhere to set location",
      setLocation: "Set Location",
      paths: "Paths"
    }
  },
  errorDialog: {
    dismiss: "Dismiss"
  },
  eventBanner: {
    close: "Close",
    atPlace: "at {{place}}"
  },
  placeBanner: {
    close: "Close"
  },
  offline: {
    message: "You are offline. Information could be out of date."
  }
};

const translations: LocaleTranslations = {
  en: canonical
};

export const supportedLanguages = new Set(Object.keys(translations));

export default translations;
